// utils/showBanModal.tsx
import ReactDOM from "react-dom/client";
import Modal from "../Components/Modal";
import store from "../Redux/Store";
import { logout, setAccessToken } from "../Redux/Slices/AuthSlice";

let isBanModalVisible = false;


export const showBanToastOnce = (message: string,modalHeader:string) => {
if (isBanModalVisible) return;
  isBanModalVisible = true;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  const handleConfirm = () => {
    store.dispatch(logout());
    store.dispatch(setAccessToken({ accessToken: "", refreshToken: "" }));
    localStorage.clear();
    sessionStorage.clear();
    closeModal();
  };

  const closeModal = () => {
    isBanModalVisible = false;
    root.unmount();
    container.remove();
  };

  root.render(
    <Modal
      isOpen={true}
      isActionBtn={false}
      onConfirm={handleConfirm}
      onClose={closeModal}
      confirmText="OK"
      title={`Account ${modalHeader}`}
      staticBackdrop={true}
    >
      <p className="text-sm text-gray-700 dark:text-gray-300">{message}</p>
    </Modal>
  );
};
